import { ValImage } from '@valbuild/next';
import { Employee } from '../../data/employees.val';
import BlankLink from '../BlankLink/BlankLink';
import Link from 'next/link';
import { val } from '../../val.config';

interface ContactFooterProps {
  title: string;
  link: { href: string; text: string };
  contactPeople: Employee[];
}

const ContactFooter: React.FC<ContactFooterProps> = ({
  title,
  link,
  contactPeople,
}) => {
  return (
    <div className="flex w-full justify-between flex-col tablet:flex-row gap-64 tablet:items-center">
      <div className="flex flex-col gap-24 flex-1">
        <h3 className="text-lg tablet:text-xl">{title}</h3>
        <BlankLink href={link.href} linkText={link.text} />
      </div>

      <div className="flex gap-16 tablet:gap-24 grid-cols-2 flex-1">
        {contactPeople.map((person, idx) => (
          <div key={idx} className="flex flex-col gap-8 flex-1">
            <ValImage
              className="object-cover aspect-3/4 w-full laptop:max-w-[330px]"
              src={person.image}
              alt={person.image?.alt}
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 330px"
            />

            <div className="flex flex-col gap-4">
              <p className="text-lg tablet:text-xl">{person.name}</p>
              <p>{person.position}</p>

              <Link
                {...val.attrs(person)}
                key={val.raw(person.email)}
                href={`mailto:${val.raw(person.email)}`}
                className="w-fit"
              >
                {val.raw(person.email)}
              </Link>

              <Link
                key={val.raw(person.phoneNumber)}
                href={`tel:${val.raw(person.phoneNumber)}`}
                className="w-fit"
              >
                {val
                  .raw(person.phoneNumber)
                  .replace(' ', '')
                  .replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactFooter;
